/**
 * Visible-screen size for phones. Browser toolbars (iPhone Safari's floating
 * tab bar in every layout, Chrome's bottom bar) can sit over the bottom of the
 * page without being reported as a safe area, so 100dvh can run under them.
 * window.visualViewport is the part of the page actually on screen; it is
 * published as CSS variables and kept current as toolbars grow and shrink:
 *   --hg-vv-height  visible height in px
 *   --hg-vv-top     how far the visible area starts below the layout top
 *   --hg-vv-bottom  how much of the layout bottom is covered (toolbar, keyboard)
 * The cart drawer (assets/happyglow.css) is sized from them on phones and the
 * product page's phone sticky bar (sections/hg-product.liquid) is lifted by
 * --hg-vv-bottom. Without visualViewport nothing is set and the CSS fallbacks
 * (100dvh, then 100vh) apply. Loaded theme-wide from snippets/scripts.liquid.
 */
(function() {
  var vv = window.visualViewport;
  if (!vv) return;
  var root = document.documentElement;
  var queued = false;

  function sync() {
    queued = false;
    // Pinch-zoom shrinks the visual viewport too; keep the last values then.
    if (vv.scale && vv.scale > 1.01) return;
    var top = Math.max(0, vv.offsetTop);
    root.style.setProperty('--hg-vv-height', vv.height + 'px');
    root.style.setProperty('--hg-vv-top', top + 'px');
    root.style.setProperty('--hg-vv-bottom', Math.max(0, window.innerHeight - vv.height - top) + 'px');
  }
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(sync);
  }

  sync();
  vv.addEventListener('resize', queue);
  vv.addEventListener('scroll', queue);
  window.addEventListener('orientationchange', queue);
})();
